import { tabAccessControl } from "../../../_helpers/access-control";

let kitComponentVisible = true;

function ProductTabs(id) {
  return [
    {
      text: "Details",
      path: `/product/review/${id}`,
      applicationFeatureCode: "Product",
    },
    {
      text: "Suppliers",
      path: `/product-supplier/review/${id}`,
      applicationFeatureCode: "ProductSupplier",
    },
    {
      text: "Costs",
      path: `/product-cost/review/${id}`,
      applicationFeatureCode: "ProductCost",
    },
    {
      text: "Sales UM",
      path: `/product-unit-of-measure/review/${id}`,
      applicationFeatureCode: "ProductUnitOfMeasure",
    },
    {
      text: "Locations",
      path: `/product-location/review/${id}`,
      applicationFeatureCode: "ProductLocation",
    },
    {
      text: "Dimensions",
      path: `/product-dimension/review/${id}`,
      applicationFeatureCode: "ProductDimension",
    },
    {
      text: "Kit Components",
      path: `/product-kit-components/review/${id}`,
      applicationFeatureCode: "Product",
      visible: kitComponentVisible
    },
  ]
}


function GetIndexByTabName(tabName, id) {
  return tabAccessControl(ProductTabs(id)).findIndex((x) => x.text == tabName);
}

function ProductTabsVisibility(obj) {
  if (obj) {
    if (obj.text == "Kit Components")
      kitComponentVisible = obj.value;
  }
}

export { ProductTabs, GetIndexByTabName, ProductTabsVisibility };